module.exports = __webpack_public_path__ + "static/media/six.13d4c222.jpg";